import { useEffect, useState } from "react";
import { MapPin } from "lucide-react";
import { classOf } from "@/lib/pls";

const PAGE = 50;

export const PlsTable = ({ rows, onFocus }) => {
  const [page, setPage] = useState(0);
  useEffect(() => {
    setPage(0);
  }, [rows]);
  const pages = Math.max(1, Math.ceil(rows.length / PAGE));
  const slice = rows.slice(page * PAGE, page * PAGE + PAGE);

  return (
    <div className="rounded-[28px] border border-sky-100 bg-white" data-testid="pls-table">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[720px] text-left text-sm">
          <thead className="font-mono text-[11px] uppercase tracking-[0.18em] text-slate-500">
            <tr className="border-b border-slate-100">
              <th className="px-5 py-3">Name</th><th className="px-3 py-3">ICAO</th><th className="px-3 py-3">IATA</th>
              <th className="px-3 py-3">Class</th><th className="px-3 py-3">Town</th><th className="px-3 py-3">State</th><th className="px-3 py-3">ERSA</th><th className="px-5 py-3" />
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {slice.map((a) => {
              const c = classOf(a);
              return (
                <tr key={a.airfield_id} className="transition-colors hover:bg-[#F4F9FD]" data-testid={`pls-row-${a.airfield_id}`}>
                  <td className="px-5 py-3 font-medium text-ink">{a.name}</td>
                  <td className="px-3 py-3 font-mono text-xs">{a.icao || "—"}</td>
                  <td className="px-3 py-3 font-mono text-xs">{a.iata || "—"}</td>
                  <td className="px-3 py-3"><span className="inline-flex items-center gap-1.5 text-xs"><span className="h-2.5 w-2.5 rounded-full" style={{ background: c.color }} />{c.label}</span></td>
                  <td className="px-3 py-3 text-slate-600">{a.municipality || "—"}</td>
                  <td className="px-3 py-3 text-slate-600">{a.state || "—"}</td>
                  <td className="px-3 py-3 text-xs">{a.ersa ? "Yes" : ""}</td>
                  <td className="px-5 py-3 text-right">
                    <button onClick={() => onFocus(a)} className="inline-flex items-center gap-1 rounded-full px-3 py-1.5 text-xs font-medium text-sky-700 hover:bg-sky-50" data-testid={`pls-row-map-${a.airfield_id}`}><MapPin className="h-3.5 w-3.5" />Map</button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {rows.length === 0 && <p className="p-10 text-center text-slate-600" data-testid="pls-table-empty">No airfields match these filters.</p>}
      <div className="flex items-center justify-between border-t border-slate-100 px-5 py-3 text-sm text-slate-600">
        <span data-testid="pls-page-info">{rows.length ? `${page * PAGE + 1}–${Math.min(rows.length, (page + 1) * PAGE)} of ${rows.length.toLocaleString()}` : "0 results"}</span>
        <div className="flex gap-2">
          <button disabled={page === 0} onClick={() => setPage(page - 1)} className="rounded-full border border-slate-200 px-3 py-1.5 disabled:opacity-40" data-testid="pls-prev-page">Prev</button>
          <button disabled={page >= pages - 1} onClick={() => setPage(page + 1)} className="rounded-full border border-slate-200 px-3 py-1.5 disabled:opacity-40" data-testid="pls-next-page">Next</button>
        </div>
      </div>
    </div>
  );
};
